import React from 'react';
import {Box, Typography} from '@mui/material';
import NationalDashboardShell from '../components/NationalDashboard.comp';

const NAVY   = '#052F44';

const PRIORITY_COLOR = {High: '#E04535', Medium: '#EFA020', Low: '#6B7280'};

const ACTION_ROWS = [
    {priority: 'High',   where: 'North East', evidence: 'Lowest participation (71%), highest any-risk (63%), lowest access',    action: 'Run a follow-up assessment and a school–family safeguarding campaign', owner: 'National COS lead'},
    {priority: 'High',   where: 'National',    evidence: 'Excessive screen time 42% and underage tech use 38% above threshold', action: 'Launch a national screen-time / age-appropriate-use campaign',          owner: 'Ministry / schools'},
    {priority: 'Medium', where: 'National',    evidence: 'Cyber Safety weakest target (57); Screen-Time Self-Control 49',       action: 'Deploy a national self-regulation & media-literacy module',             owner: 'Education agency'},
    {priority: 'Medium', where: 'National',    evidence: 'Trust in seeking help is low (context)',                             action: 'Strengthen visible reporting and help-seeking pathways',                owner: 'Safeguarding agency'},
    {priority: 'Low',    where: 'National',    evidence: 'Module coverage (62%) trails assessment coverage; Target 2 flat',     action: 'Close the implementation gap and re-target next cycle',                 owner: 'COS lead / partners'},
];

const PriorityPill = ({priority}) => (
    <Box sx={{
        display: 'inline-block', backgroundColor: PRIORITY_COLOR[priority] || '#6B7280', color: '#ffffff',
        fontSize: '12px', fontWeight: 700, px: 1.5, py: 0.4, borderRadius: '20px', textAlign: 'center', minWidth: '64px',
    }}>
        {priority}
    </Box>
);

const ActionPlanSection = () => (
    <NationalDashboardShell skipNoDataGate>
        {/* Page header */}
        <Box sx={{mb: 2}}>
            <Typography sx={{fontSize: '23px', fontWeight: 800, color: NAVY, lineHeight: 1.2, mb: 0.8}}>
                Recommended National Action Plan
            </Typography>
            <Typography sx={{fontSize: '14px', color: '#4B5563', fontStyle: 'italic'}}>
                What should government and implementation partners do next?
            </Typography>
        </Box>
        <Typography sx={{fontSize: '12px', color: '#9CA3AF', mb: 2.5}}>
            United Kingdom · COS Children · assessment cycle 2026 · illustrative data
        </Typography>

        <Box sx={{border: '1px solid var(--brand-border, #E5E7EB)', borderRadius: '12px', backgroundColor: 'var(--brand-surface, #ffffff)', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', overflow: 'hidden'}}>
            {/* Table header */}
            <Box sx={{display: 'grid', gridTemplateColumns: '90px 130px 1fr 1fr 160px', backgroundColor: NAVY, px: 2.5, py: 1.4}}>
                <Typography sx={{fontSize: '13px', fontWeight: 700, color: '#ffffff'}}>Priority</Typography>
                <Typography sx={{fontSize: '13px', fontWeight: 700, color: '#ffffff'}}>Target Region</Typography>
                <Typography sx={{fontSize: '13px', fontWeight: 700, color: '#ffffff'}}>Evidence</Typography>
                <Typography sx={{fontSize: '13px', fontWeight: 700, color: '#ffffff'}}>Recommended national action</Typography>
                <Typography sx={{fontSize: '13px', fontWeight: 700, color: '#ffffff'}}>Responsibility</Typography>
            </Box>

            {/* Table rows */}
            {ACTION_ROWS.map((row, i) => (
                <Box key={i} sx={{
                    display: 'grid',
                    gridTemplateColumns: '90px 130px 1fr 1fr 160px',
                    alignItems: 'center',
                    px: 2.5, py: 2,
                    gap: 1.5,
                    backgroundColor: i % 2 === 0 ? 'var(--brand-surface, #ffffff)' : 'var(--brand-surface-subtle, #F9FAFB)',
                    borderTop: '1px solid #F3F4F6',
                }}>
                    <PriorityPill priority={row.priority}/>
                    <Typography sx={{fontSize: '13px', fontWeight: 700, color: NAVY}}>{row.where}</Typography>
                    <Typography sx={{fontSize: '13px', color: '#374151', lineHeight: 1.6}}>{row.evidence}</Typography>
                    <Typography sx={{fontSize: '13px', color: '#374151', lineHeight: 1.6}}>{row.action}</Typography>
                    <Typography sx={{fontSize: '13px', color: '#374151'}}>{row.owner}</Typography>
                </Box>
            ))}
        </Box>
    </NationalDashboardShell>
);

export default ActionPlanSection;
